<script setup>
import { ref, nextTick } from 'vue';
import Dialog from 'dashboard/components-next/dialog/Dialog.vue';
import KnowledgeBaseAPI from 'dashboard/api/knowledgeBase';
import { useAlert } from 'dashboard/composables';

const emit = defineEmits(['deleted']);

const dialogRef = ref(null);
const itemToDelete = ref(null);
const isLoading = ref(false);

const open = (item) => {
  itemToDelete.value = item;
  isLoading.value = false;
  nextTick(() => {
    dialogRef.value?.open();
  });
};

const close = () => {
  dialogRef.value?.close();
};

const confirmDelete = async () => {
  if (!itemToDelete.value) return;
  isLoading.value = true;
  try {
    await KnowledgeBaseAPI.deleteItem(itemToDelete.value.id);
    useAlert('知识条目已删除 ✓');
    emit('deleted');
    close();
  } catch (error) {
    useAlert(error.response?.data?.error || error.message || '删除失败');
  } finally {
    isLoading.value = false;
  }
};

defineExpose({ open, close });
</script>

<template>
  <Dialog
    ref="dialogRef"
    type="alert"
    title="删除知识条目"
    confirm-button-label="确认删除"
    cancel-button-label="取消"
    :is-loading="isLoading"
    width="md"
    @confirm="confirmDelete"
  >
    <div class="py-2 text-sm text-n-slate-11">
      确定要删除知识条目
      <span class="font-medium text-n-slate-12">“{{ itemToDelete?.title }}”</span> 吗？
      <p class="mt-2 text-xs text-n-ruby-11 font-normal">
        删除后，AI 将不再依据该知识进行回答，该操作无法撤销。
      </p>
    </div>
  </Dialog>
</template>
